import { ajax } from "../services/ajax"
import { api } from "../constants";

export default ids => {
  return ajax.get(api.endpoints.tracksById(ids.toString().split(',').join(',')))
}